import React from 'react';
import { CaseDetailPage } from 'containers/pages/cases/components';

export default function CaseDetail() {
	return <CaseDetailPage />;
}
